// src/pages/Contact.jsx

import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>

      {/* Info Cards */}
      <div className="contact-info-cards">
        <div className="info-card">
          <div className="info-icon">
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <div className="info-details">
            <h3>Location</h3>
            <p>
              Paschimpara, Beside Paschimpara Club<br />
              Haldibari, West Bengal, India, 735122
            </p>
          </div>
        </div>

        <div className="info-card">
          <div className="info-icon">
            <i className="fas fa-phone"></i>
          </div>
          <div className="info-details">
            <h3>Phone</h3>
            <p>+91-7908952113</p>
          </div>
        </div>

        <div className="info-card">
          <div className="info-icon">
            <i className="fas fa-envelope"></i>
          </div>
          <div className="info-details">
            <h3>Email</h3>
            <p>biswaskaushik532@gmail.com</p>
          </div>
        </div>

        <div className="info-card">
          <div className="info-icon">
            <i className="fas fa-clock"></i>
          </div>
          <div className="info-details">
            <h3>Business Hours</h3>
            <p>Mon-Sat: 9 AM - 9 PM</p>
          </div>
        </div>
      </div>

      {/* Book Appointment Button (top) */}
      <div className="contact-appointment">
        <button className="appointment-btn">Book an Appointment</button>
      </div>

      {/* Google Map Embed */}
      <div className="map-container">
        <iframe
          title="clinic-location-map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.609235985049!2d88.77551971120286!3d26.337204784489487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e481ef7d2f23e5%3A0x4e7caee93dd54506!2sSensasion%20Physiotherapy%20Clinic!5e1!3m2!1sen!2sin!4v1735757196262!5m2!1sen!2sin"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Contact Form */}
      <div className="form-section">
        <h2>Get in Touch</h2>
        <form className="contact-form">
          <label>Name</label>
          <input type="text" placeholder="Your Name" />

          <label>Email</label>
          <input type="email" placeholder="Your Email" />

          <label>Message</label>
          <textarea rows="4" placeholder="Your Message"></textarea>

          <button type="submit" className="form-submit-btn">
            Send Message
          </button>
        </form>
      </div>

      {/* Social Media Links (Optional) */}
      <div className="social-links">
        <p>Follow Us:</p>
        <a href="https://facebook.com" target="_blank" rel="noreferrer">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer">
          <i className="fab fa-instagram"></i>
        </a>
        {/* Add other socials if desired */}
      </div>
    </div>
  );
}

export default Contact;
